export const PrefixLabel = {
  FRONTEND_ERRORS: "error.frontend.",
  BACKEND_ERRORS: "error.backend.",
  CONFIRMATION_DIALOG_MESSAGES: "confirmation-dialog.messages.",
  EVENT_TAGS: "enums.event-tags.",
  USER_INTERESTS: "enums.user-interests."
} as const;
